import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Sample} from "../models-new/sample";

@Component({
    selector: 'app-duplicate-sample-selection',
    templateUrl: './duplicate-sample-selection.component.html',
})
export class DuplicateSampleSelectionComponent {
    @Input() duplicateSamples: Sample[] = [];
    @Output() sampleSelectionEmitter: EventEmitter<string> = new EventEmitter<string>();
    @Input() skipSampleDisability = false;

    selectedSampleFromDuplicate(sample_objectId: string): void {
        this.sampleSelectionEmitter.emit(sample_objectId);
    }

    checkIfSampleIsDisabledForSelection(sample: Sample): boolean {
        if(this.skipSampleDisability){
            return false;
        }
        return sample.receptionStatus === "REMOVED" || sample.sampleCompletionDate !== null;
    }
}
